<template>
  <main role="main">
    <div class="container-fluid no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-4 mb-2 mt-2">
          <input class="form-control btn-more-radius" @keyup.enter="getSerials()" v-model="queryModel.SerialNumber"
            type="text" placeholder="Cihaz seri numarası ile arama yapın...">
        </div>
        <div class="col mb-2 mt-2">
          <select class="custom-select btn-more-radius" v-model="queryModel.MalzemeId" @change="getSerials()">
            <option selected value="-1">Tüm Malzemeler</option>
            <option v-for="(item, index) in sarflar" v-bind:key="'item-'+index" :value="item.MALZEME_ID">{{item.MALZEME_NAME}}</option>
          </select>
        </div>
        <div class="col mb-2 mt-2">
          <select class="custom-select btn-more-radius" v-model="queryModel.SerialStatus" @change="getSerials()">
            <option selected value="-1">Tüm Stoklar...</option>
            <option value="0">Lenoi Stok</option>
            <option value="1">Ü.M.E. Stok</option>
            <option value="2">Fabrika Stok / Üretim Stoku</option>
            <option value="3">Çıkışı Yapılmışlar</option>
            <option value="4">Arızalı / Arıza Kayıt Listesinde</option>
            <option value="5">Ölü Ürün / Stok Dışı</option>
          </select>
        </div>
        <div class="col mb-2 mt-2">
          <select :disabled="(queryModel.SerialStatus == 3 || queryModel.SerialStatus == 4) == false" class="custom-select btn-more-radius"
            v-model="queryModel.RetailerId" @change="getSerials()">
            <option selected value="-1">Tüm Bayiiler...</option>
            <option value="1">LENOİ</option>
            <option value="2">NOKKON</option>
            <option value="3">ZİMİR</option>
            <option value="4">İNTERGLOBAL</option>
            <option value="5">BÜLENT EŞKİ</option>
            <option value="6">AROMİL</option>
            <option value="9">SECAN GÜVENLİK</option>
            <option value="10">CANTEL ELEKTRONİK</option>
            <option value="11">PTT</option>
            <option value="13">ASİS ELEKTRONİK</option>
            <option value="14">DCA</option>
            <option value="15">NOKITECH</option>
            <option value="16">FİLOSİSTEM</option>
            <option value="17">SEZGİN KOÇ</option>
            <option value="18">DİĞER</option>
          </select>
        </div>
        <div class="col-md-2 mb-2 mt-2">
          <button class="btn btn-more-radius btn-success float-right" data-toggle="modal"
            @click="openModalInsert()" data-target="#modalAddSerialNumber"
            v-if="canAddSerialNumber">Seri No Ekle</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="serials-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-hover">
              <thead>
                <tr class="thead-light">
                  <th class="align-middle" style="width: 1%;" scope="col">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="selectAll" id="checkAllUcks">
                      <label class="custom-control-label" for="checkAllUcks"></label>
                    </div>
                  </th>
                  <th style="width: 8%;" scope="col">OLUŞTURMA</th>
                  <th style="width: 12%;" scope="col">SERİ NO.</th>
                  <th style="width: 10%;" scope="col">ÜRÜN TÜRÜ</th>
                  <th style="width: 15%;" scope="col">BAYİİ / MÜŞTERİ</th>
                  <th style="width: 10%;" scope="col">DURUM</th>
                  <th scope="col" class="text-center">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <tr v-for="(serial) in serials" :key="'serial-' + serial.SERIAL_NUMBER_ID">
                  <td class="align-middle" style="width: 1%;">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" :value="serial.SERIAL_NUMBER_ID"
                        v-model="selectedSerials" v-bind:id="'tcheck-'+serial.SERIAL_NUMBER_ID">
                      <label class="custom-control-label" v-bind:for="'tcheck-'+serial.SERIAL_NUMBER_ID"></label>
                    </div>
                  </td>
                  <td class="align-middle">{{serial.SERIAL_CREATED_FORMATTED}}</td>
                  <td class="align-middle">
                    <div class="text-truncate justify-content-between">
                      <p class="my-0 font-semi-bold">{{serial.SERIAL_NUMBER}}</p>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="text-truncate justify-content-between">
                      <p class="my-0 font-semi-bold">{{serial.MALZEME_NAME}}</p>
                      <small class="text-muted">{{serial.MALZEME_CODE}}</small>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold text-truncate">{{serial.RETAILER_NAME}}</p>
                      <small v-if="serial.CUSTOMER_TITLE || serial.VEHICLE_NAME" class="text-muted">{{serial.CUSTOMER_TITLE + ' - ' + serial.VEHICLE_NAME}}</small>
                    </div>
                  </td>
                  <td style="width: 12%; max-width:12%;" class="align-middle text-center">
                    <div class="text-truncate">
                      <span class="btn btn-more-radius btn-sm" :class="parseStatusForClass(serial.SERIAL_STATUS)">{{parseStatusForView(serial.SERIAL_STATUS)}}</span>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canAddSerialNumber" class="modal fade bd-example-modal-lg"  id="modalAddSerialNumber" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Seri Numarası Girişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="serials-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Seri Numaraları Ekleniyor</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-id">Malzeme</label>
                    <select class="custom-select" v-model="insertModel.MalzemeId">
                      <option selected value="-1">Malzeme Seçiniz...</option>
                      <option v-for="(item, index) in sarflar" v-bind:key="'item-'+index" :value="item.MALZEME_ID">{{item.MALZEME_NAME}}</option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="serial-status">Durum</label>
                    <select class="custom-select" v-model="insertModel.SerialStatus">
                      <option selected value="-1">Stok türü seçiniz...</option>
                      <option value="0">Lenoi Stok</option>
                      <option value="1">Ü.M.E. Stok</option>
                      <option value="2">Fabrika Stok / Üretim Stoku</option>
                      <option value="3">Çıkışı Yapılmışlar</option>
                      <option value="4">Arızalı</option>
                      <option value="5">Ölü Ürün / Stok Dışı</option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="serial-status">Bayii</label>
                    <select :disabled="(insertModel.SerialStatus == 3 || insertModel.SerialStatus == 4) == false"
                      class="custom-select" v-model="insertModel.RetailerId">
                      <option selected value="-1">Bayii Seçiniz...</option>
                      <option value="1">LENOİ</option>
                      <option value="2">NOKKON</option>
                      <option value="3">ZİMİR</option>
                      <option value="4">İNTERGLOBAL</option>
                      <option value="5">BÜLENT EŞKİ</option>
                      <option value="6">AROMİL</option>
                      <option value="9">SECAN GÜVENLİK</option>
                      <option value="10">CANTEL ELEKTRONİK</option>
                      <option value="11">PTT</option>
                      <option value="13">ASİS ELEKTRONİK</option>
                      <option value="14">DCA</option>
                      <option value="15">NOKITECH</option>
                      <option value="16">FİLOSİSTEM</option>
                      <option value="17">SEZGİN KOÇ</option>
                      <option value="18">DİĞER</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="serial-numbers">Eklenecek Seri Numaraları</label>
                    <textarea class="form-control" rows="10" id="serial-numbers" v-model="insertModel.SerialNumber" />
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="insertSerials()" class="btn btn-success">Seri Numaralarını Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'StokPage',
  data () {
    return {
      sarflar: [],
      serials: [],
      selectedSerials: [],
      insertModel: {
        SessionId: '',
        MalzemeId: -1,
        SerialStatus: -1,
        RetailerId: 1,
        SerialNumber: '',
        IsMultiple: true
      },
      queryModel: {
        SessionId: '',
        SerialNumber: '',
        RetailerId: -1,
        SerialStatus: -1,
        MalzemeId: -1,
      },
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canAddSerialNumber : function() { return this.$store.getters.userCanViewStok },
    selectAll: {
      get: function () {
        return this.selectedSerials ? this.serials.length == this.selectedSerials.length && this.serials.length > 0 : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.serials.forEach(function (serial) {
            selected.push(serial.SERIAL_NUMBER_ID);
          });
        }
        this.selectedSerials = selected;
      }
    }  
  },
  methods: {
    getSerials() {
      this.$wait.start('serials-loading')
      this.queryModel.SessionId = this.getSessionId
      axios.post('/api/stok/tum-serinumaralar', this.queryModel)
      .then(response => {
        this.serials = response.data
        this.$wait.end('serials-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('serials-loading')
      })
    },
    getSarflar() {
      axios.post('/api/stok/sarflar-with-serials?sessionId='+ this.getSessionId)
      .then(response => {
        this.sarflar = response.data
        this.$wait.end('serials-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('serials-loading')
      })
    },
    insertSerials() {
      if(this.insertModel.MalzemeId == -1) {
        this.$toasted.error('Malzeme seçimi yapmadınız.', this.toastOptions)
        return;
      }

      if(this.insertModel.SerialStatus == -1) {
        this.$toasted.error('Stok türü seçimi yapmadınız.', this.toastOptions)
        return;
      }

      if(this.insertModel.SerialNumber.length == 0) {
        this.$toasted.error('Seri numarası eklemediniz.', this.toastOptions)
        return;
      }

      this.$wait.start('serials-inserting')
      this.insertModel.SessionId = this.getSessionId

      axios.post('/api/stok/serino-ekle', this.insertModel)
      .then(response => {
        //this.getSerials()
        this.clearInsertModel()
      })
      .catch(error => { 
        console.error(error) 
      })

      this.$wait.end('serials-inserting')
      $("#modalAddSerialNumber").modal('hide')
    },
    openModalInsert() {},
    clearInsertModal() {
      this.insertModel.RetailerId = -1
      this.insertModel.SerialStatus = -1
      this.insertModel.SerialNumber = ''
      this.insertModel.MalzemeId = -1
    },
    parseStatusForClass(status) {
      if(status == 0)
        return "btn-primary"
      if(status == 1)
        return "btn-secondary"
      if(status == 2)
        return "btn-success"
      if(status == 3)
        return "btn-info"
      if(status == 4)
        return "btn-warning"
      if(status == 5)
        return "btn-danger"
    },
    parseStatusForView(status) {
      if(status == 0)
        return "LENOİ STOK"
      if(status == 1)
        return "Ü.M.E. STOK"
      if(status == 2)
        return "FABRİKA STOK"
      if(status == 3)
        return "ÇIKIŞI YAPILDI"
      if(status == 4)
        return "ARIZALI / ARIZA LİSTESİNDE"
      if(status == 5)
        return "ÖLÜ ÜRÜN / STOK DIŞI"
    }
  },
  mounted() {
    this.getSerials()
    this.getSarflar()
  }
}
</script>

<style scoped>

  .table-bordered{
    border-color: #F7F7F7
  }

  table, .dropdown-item {
    font-size: .875rem;
  }

  .thead-fixed {
    position: fixed;
    z-index: 1;
    top: 60px;
    left: 0;
    right: 0;
    width: 100%;
    table-layout: fixed;
    display: table; 
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  td .btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .font-semi-bold {
    font-weight: 500;
  }

</style>


// WEBPACK FOOTER //
// src/components/SerialPage.vue